export const groupByArrayOfObject = (array, key) => {
  // Return the end result
  return array.reduce((result, currentValue) => {
    result[currentValue[key]] = currentValue

    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}) // empty object is the initial value for result object
}

export const getFirstOfArray = (arr) => {
  return arr[ Object.keys(arr)[0] ]
}

export const makeSelectable = (arr, value, label) => {
  const grouped = groupByArrayOfObject(arr, value)
  return Object.keys(grouped).map((key) => {
    return {
      value: key,
      label: grouped[key][label],
    }
  })
}

export const arrayOfObject = (objOfObjs) => Object.entries(objOfObjs).map((e) => ( e[1] ))

export const mergeIt = (a, b, primaryKey = 'id') => {
  const aIDs = new Set(a.map(aItem => aItem[primaryKey]))

  a = a.map(aItem => {
      return {...aItem, ...b.find(bItem => bItem[primaryKey] === aItem[primaryKey])}
  })

  const c = b.filter(bItem => !aIDs.has(bItem[primaryKey]))

  return a.concat(c)
}

export const getDifference = (array1, array2, primaryKey = 'id') => {
  return array1.filter(
    object1 => !array2.some(object2 => object1[primaryKey] === object2[primaryKey])
  )
}